<template>
  <tr>
    <td>({{ domain.id }}) {{ domain.url }}</td>
    <td>
      <select @change="update" class="form-control" v-model="domain.type">
        <option v-for="(type, id) in types" :value="id">{{ type }}</option>
      </select>
    </td>
    <td>
      <i v-if="check && check.is_check_success" class="icon-fa icon-fa-check-circle"></i>
      ({{ check && check.attempts }})
    </td>
    <td>
      <div v-if="check && check.response_data">
        <template v-if="check && !check.is_check_success || check.is_blocked">
          {{ check.response_data.message || (check.response_data.error && check.response_data.error.msg) }}
        </template>
      </div>
    </td>
    <td>
      <div class="form-group">
        <input @change="update" v-model="domain.not_inform" type="checkbox">
      </div>
    </td>
    <td>
      <div class="flex">
        <button class="btn btn-danger" @click="deleteRecord">
          <i class="icon-fa icon-fa-trash-o" aria-hidden="true"></i>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  props: ['domain', 'types', 'check', 'updateRecord'],
  methods: {
    deleteRecord() {
      this.updateRecord('delete', this.domain)
    },
    update() {
      this.updateRecord('update', this.domain)
    }
  }
}

</script>
